module.exports = __webpack_public_path__ + "static/022.thumb-556891c792cc66787e0ce47f6b2bc6fd.jpg";